import { withRouter } from 'react-router-dom'
import useMovimentacaoEstoque, {
  LOAD_MESSAGE,
  TIPO_LISTAGEM_POR_PALLET,
} from './MovimentacaoEstoqueRecebimentoHook'
import { connect } from 'react-redux'
import {
  Btn,
  CustomCalendar,
  CustomDataTableHeader,
  CustomDropdown,
  CustomPanel,
  InputDate,
  InputNumeroInteiro,
  InputText,
  InputTime,
  PageHeader,
  Periodo,
} from '../../../../../components'
import React, { useEffect } from 'react'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import { DataTable } from 'primereact/datatable'
import './MovimentacaoEstoqueRecebimento.css'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../../assets/js/styles'

function MovimentacaoEstoqueRecebimento({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useMovimentacaoEstoque()

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.PICKINGS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getPickings(selectedTp, state.periodo.dataInicial, state.periodo.dataFinal)
        break

      case LOAD_MESSAGE.PALLETAREAS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getPalletAreas(state.selectedPicking.id)
        break

      case LOAD_MESSAGE.PALLETAREAS_PRODUTOS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getPalletAreasProdutos(state.selectedPicking.id)
        break

      case LOAD_MESSAGE.PRODUTOS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getProdutos(state.selectedPicking.id)
        break

      case LOAD_MESSAGE.POSICOES:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getPosicoesEstoque(selectedTp, state.selectedEstoque.id)
        break

      case LOAD_MESSAGE.MOVING:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  useEffect(() => {
    if (state.pathToRedirect) {
      history.push(state.pathToRedirect, { selectedPicking: state.selectedPick })
    }
  }, [state.pathToRedirect])

  function showTypeListIfStylePickingEqualCodigoBarra(selectedPicking) {
    if (selectedPicking && selectedPicking.style === 'Codigo de Barra')
      return (
        <div className="p-col-3">
          <CustomDropdown
            placeholder="Selecione um Tipo"
            optionLabel={'name'}
            options={[TIPO_LISTAGEM_POR_PALLET]}
            label={'Tipo de Listagem'}
            onChange={() => {}}
            value={state.selectedTipoListagem || TIPO_LISTAGEM_POR_PALLET}
            disabled
          />
        </div>
      )
  }

  return (
    <div>
      <PageHeader>8.3 - Movimentações de Estoque - Recebimento</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={() => {}} showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-3">
              <CustomDropdown
                placeholder="Selecione uma Operação"
                optionLabel={'name'}
                options={state.operacoes}
                label={'Operação de Estoque'}
                onChange={value => localDispatch.onChange('selectedOperacao', value)}
                value={state.selectedOperacao}
              />
            </div>
            <div className="p-col-3">
              <CustomCalendar
                label={'Data da Movimentação'}
                onChange={value => localDispatch.onChange('dataMovimentacao', value)}
                value={state.dataMovimentacao}
              />
            </div>
            <div className="p-col-2" style={{ marginTop: -10 }}>
              <InputTime
                label={'Hora da Movimentação'}
                value={state.horaMovimentacao}
                onChange={value => localDispatch.onChange('horaMovimentacao', value)}
              />
            </div>
          </div>
          <div className="p-grid">
            <div className="p-col-5">
              <Periodo
                periodoInicial={state.periodo.dataInicial}
                periodoFinal={state.periodo.dataFinal}
                onPesquisar={localDispatch.onBtnPesquisarClick}
                textPesquisar="Pesquisar Pickings"
              />
            </div>
            <div className="p-col-3">
              <CustomDropdown
                placeholder="Selecione um Picking"
                optionLabel={'name'}
                options={state.pickings}
                label={'Pickings'}
                onChange={value => localDispatch.onChange('selectedPicking', value)}
                value={state.selectedPicking}
              />
            </div>
            {showTypeListIfStylePickingEqualCodigoBarra(state.selectedPicking)}
          </div>
          <div
            className="p-grid p-align-start"
            style={{
              margin: '0px 0px',
              padding: '10px',
              border: '0.5px solid #c8c8c8',
              borderRadius: '4px',
              height: '100%',
            }}
          >
            {!state.selectedPicking ? (
              <></>
            ) : (
              <>
                {state.selectedPicking.style === 'Manual' ? (
                  <div
                    className="p-col-6 p-grid p-justify-center container-items relative scroll"
                    style={{ padding: 0 }}
                  >
                    {state.selectedPicking.style === 'Manual' ? (
                      <DataTable
                        value={state.produtos}
                        dataKey="rowKey"
                        header={
                          <CustomDataTableHeader
                            onChange={value => localDispatch.onChange('globalFilter', value)}
                            children={
                              <div
                                style={{
                                  display: 'inline-grid',
                                  gap: '10px',
                                  gridAutoFlow: 'column',
                                  marginLeft: 20,
                                }}
                              >
                                <Btn
                                  onClick={() =>
                                    localDispatch.onClickAlocar(
                                      state.pallets,
                                      state.selectedProdutos,
                                      state.selectedPosicao,
                                      state.selectedPicking.style,
                                    )
                                  }
                                >
                                  Alocar
                                </Btn>
                                <Btn
                                  onClick={() =>
                                    localDispatch.onClickDesalocar(
                                      state.pallets,
                                      state.selectedProdutos,
                                      state.selectedPicking.style,
                                    )
                                  }
                                >
                                  Desalocar
                                </Btn>
                              </div>
                            }
                          />
                        }
                        selection={state.selectedProdutos}
                        onSelectionChange={e => localDispatch.onChange('selectedProdutos', e.value)}
                        globalFilter={state.globalFilter}
                        paginator={true}
                        rows={10}
                        emptyMessage="Não existem produtos a serem exibidos"
                      >
                        <Column selectionMode="multiple" style={{ width: '3em' }} />
                        <Column field="name" header="Produto" />
                        <Column
                          field="qte_total"
                          header="Qte Total"
                          style={tableCellCentered(80)}
                        />
                        <Column
                          field="qte_alocar"
                          header="Qte Para Alocar"
                          body={produto => (
                            <InputNumeroInteiro
                              value={produto.qte_alocar}
                              onChange={value =>
                                localDispatch.onChangeProduto(produto.rowKey, value, 'qte_alocar')
                              }
                            />
                          )}
                          style={tableCellCentered(80)}
                        />
                        <Column
                          field="validade"
                          header="Validade"
                          body={produto => (
                            <InputDate
                              value={produto.validade}
                              onChange={value =>
                                localDispatch.onChangeProduto(produto.rowKey, value, 'validade')
                              }
                            />
                          )}
                          style={tableCellCentered(120)}
                        />
                        <Column
                          field="lote"
                          header="Lote"
                          body={produto => (
                            <InputText
                              value={produto.lote}
                              onChange={value =>
                                localDispatch.onChangeProduto(produto.rowKey, value, 'lote')
                              }
                            />
                          )}
                          style={tableCellCentered(80)}
                        />
                        <Column field="pos_estoque" header="Posição" />
                      </DataTable>
                    ) : (
                      <DataTable
                        value={state.produtos}
                        dataKey="rowKey"
                        header={
                          <CustomDataTableHeader
                            onChange={value => localDispatch.onChange('globalFilter', value)}
                            children={
                              <div
                                style={{
                                  display: 'inline-grid',
                                  gap: '10px',
                                  gridAutoFlow: 'column',
                                  marginLeft: 20,
                                }}
                              >
                                <Btn
                                  onClick={() =>
                                    localDispatch.onClickAlocar(
                                      state.pallets,
                                      state.selectedProdutos,
                                      state.selectedPosicao,
                                      state.selectedPicking.style,
                                      state.selectedTipoListagem.value,
                                    )
                                  }
                                >
                                  Alocar
                                </Btn>
                                <Btn
                                  onClick={() =>
                                    localDispatch.onClickDesalocar(
                                      state.pallets,
                                      state.selectedProdutos,
                                      state.selectedPicking.style,
                                      state.selectedTipoListagem.value,
                                    )
                                  }
                                >
                                  Desalocar
                                </Btn>
                              </div>
                            }
                          />
                        }
                        selection={state.selectedProdutos}
                        onSelectionChange={e => localDispatch.onChange('selectedProdutos', e.value)}
                        globalFilter={state.globalFilter}
                        paginator={true}
                        rows={10}
                        emptyMessage="Não existem produtos a serem exibidos"
                      >
                        <Column selectionMode="multiple" style={{ width: '3em' }} />
                        <Column
                          field="pallet_area_id"
                          header="Pallet"
                          style={tableCellCentered(90)}
                        />
                        <Column field="name" header="Produto" />
                        <Column
                          field="qte_total"
                          header="Qte Total"
                          style={tableCellCentered(80)}
                        />
                        <Column
                          field="qte_alocar"
                          header="Qte Para Alocar"
                          body={produto => (
                            <InputNumeroInteiro
                              value={produto.qte_alocar}
                              onChange={value =>
                                localDispatch.onChangeProduto(produto.rowKey, value, 'qte_alocar')
                              }
                            />
                          )}
                          style={tableCellCentered(80)}
                        />
                        <Column field="validade" header="Validade" />
                        <Column field="lote" header="Lote" />
                        <Column field="pos_estoque" header="Posição" />
                      </DataTable>
                    )}
                  </div>
                ) : (
                  <div
                    className="p-col-6 p-grid p-justify-center container-items relative scroll"
                    style={{ padding: 0 }}
                  >
                    <div className="p-col-12 p-grid header-section">
                      <DataTable
                        value={state.pallets}
                        header={
                          <CustomDataTableHeader
                            onChange={value => localDispatch.onSearchPalletsChange(value)}
                            children={
                              <div
                                style={{
                                  display: 'inline-grid',
                                  gap: '10px',
                                  gridAutoFlow: 'column',
                                  marginLeft: 20,
                                }}
                              >
                                <Btn
                                  onClick={() =>
                                    localDispatch.onClickAlocar(
                                      state.selectedPallets,
                                      state.selectedProdutos,
                                      state.selectedPosicao,
                                      state.selectedPicking.style,
                                      state.selectedTipoListagem
                                        ? state.selectedTipoListagem.value
                                        : null,
                                    )
                                  }
                                >
                                  Alocar
                                </Btn>
                                <Btn
                                  onClick={() =>
                                    localDispatch.onClickDesalocar(
                                      state.selectedPallets,
                                      state.selectedProdutos,
                                      state.selectedPicking.style,
                                    )
                                  }
                                >
                                  Desalocar
                                </Btn>
                              </div>
                            }
                          />
                        }
                        selection={state.selectedPallets}
                        onSelectionChange={e => localDispatch.onChange('selectedPallets', e.value)}
                        globalFilter={state.searchPallet}
                        paginator={true}
                        rows={10}
                        emptyMessage="Não existem pallets a serem exibidos"
                      >
                        <Column selectionMode="multiple" style={{ width: '3em' }} />
                        <Column field="id" header="Pallet Area ID" />
                        <Column
                          field="qte_caixas"
                          header="Qte Caixas"
                          style={tableCellCentered(80)}
                        />
                        <Column field="pos_estoque" header="Posição" />
                      </DataTable>
                    </div>
                  </div>
                )}
                <div className="p-col-6" style={{ paddingTop: 0 }}>
                  <div
                    className="p-grid p-align-start"
                    style={{ margin: '0px 0px', padding: '10px', height: '100%' }}
                  >
                    <div className="p-col-12 p-grid p-justify-center container-items relative scroll">
                      <DataTable
                        value={state.posicoes}
                        header={
                          <CustomDataTableHeader
                            onChange={value => localDispatch.onSearchPosicoesChange(value)}
                            children={
                              <div
                                className="p-grid"
                                style={{
                                  display: 'inline-flex',
                                  flexWrap: 'nowrap',
                                  width: '100%',
                                  marginLeft: 11,
                                  marginTop: 1,
                                }}
                              >
                                <div className="p-col-6">
                                  <CustomDropdown
                                    marginTop={0}
                                    placeholder="Selecione um estoque"
                                    optionLabel={'name'}
                                    options={state.estoques}
                                    onChange={value =>
                                      localDispatch.onChange('selectedEstoque', value)
                                    }
                                    value={state.selectedEstoque}
                                  />
                                </div>
                                <div className="p-col-3" style={{ marginLeft: 20 }}>
                                  <Btn
                                    onClick={() =>
                                      localDispatch.onClickConcluir(
                                        state.pallets,
                                        state.produtos,
                                        state.dataMovimentacao,
                                        state.horaMovimentacao,
                                        state.selectedOperacao,
                                        state.selectedPicking,
                                        state.selectedCycle,
                                        selectedTp,
                                        state.selectedPicking.style,
                                        state.selectedTipoListagem
                                          ? state.selectedTipoListagem.value
                                          : null,
                                      )
                                    }
                                  >
                                    {' '}
                                    Concluir{' '}
                                  </Btn>
                                </div>
                              </div>
                            }
                          />
                        }
                        selection={state.selectedPosicao}
                        onSelectionChange={e => localDispatch.onChange('selectedPosicao', e.value)}
                        globalFilter={state.searchPosicao}
                        paginator={true}
                        rows={10}
                        emptyMessage="Não existem posições a serem exibidas"
                      >
                        <Column selectionMode="single" style={{ width: '5em' }} />
                        <Column field="endereco" header="Endereço" />
                        <Column
                          field="capacidade"
                          header="Capacidade"
                          style={tableCellCentered()}
                        />
                        <Column
                          field="pallets"
                          header="Pallets Alocados"
                          style={tableCellCentered()}
                        />
                        <Column
                          field="caixas"
                          header="Caixas Alocadas"
                          style={tableCellCentered()}
                        />
                      </DataTable>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </CustomPanel>
      </div>
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(MovimentacaoEstoqueRecebimento))
